import * as React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled from 'styled-components';
import * as grid from '@helpcenter/styles/src/grid';
import * as mixins from '@helpcenter/styles/src/mixins';
import ErrorIcon from '@atlaskit/icon/glyph/error';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

interface Props {
    title: React.ReactNode;
    message: React.ReactNode;
    noPadding?: boolean;
}

const ErrorMessage: React.FunctionComponent<Props> = ({ title, message }) => {
    return (
        // Ensures users can always tab from the error message
        // eslint-disable-next-line styled-components-a11y/no-noninteractive-tabindex
        <Container tabIndex={0} data-test-id="error-message">
            <Header>
                <Title>
                    <Icon>
                        <ErrorIcon label="error" secondaryColor={token('color.icon.inverse', colors.N0)} />
                    </Icon>

                    {title}
                </Title>
            </Header>
            <Content>{message}</Content>
        </Container>
    );
};

export default ErrorMessage;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const Container = styled.div`
    ${mixins.borderBox};
    ${mixins.borderRadius};
    padding: ${token('space.200', '16px')} 0;
    color: ${token('color.text.danger', colors.R500)};
    margin-top: ${token('space.100', '8px')};
    &:focus {
        outline: none;
    }
`;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const Header = styled.div`
    display: flex;
    align-items: center;
    height: ${grid.multiple(4).px};
`;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const Content = styled.div`
    display: flex;
    flex: 1 1 100%;
    flex-direction: column;
    justify-content: center;
`;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const Icon = styled.div`
    margin-right: ${token('space.050', '4px')};
`;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const Title = styled.span`
    ${mixins.clamp};
    color: ${token('color.text.danger', colors.R500)};
    display: flex;
    align-items: center;
    flex: 1;
    font-weight: 600;
`;
